import { useState } from "react";
import { BsShop } from "react-icons/bs";

export const BrandImage = ({ src, className }) => {
  const [failedSource, setFailedSource] = useState(null);
  if (!src || failedSource === src) {
    return <BsShop className={className} role="img" aria-label="Logotipo de tienda no disponible" size={40} />;
  }
  return <img src={src} alt="Logotipo de la tienda" className={className} onError={() => setFailedSource(src)} />;
};
